/**
 * Trío ABC / DEF / … según primera letra (misma tabla que Dictionary al cargar término).
 */
export function lettersTrioFromFirstChar(prefix) {
    const raw = prefix == null ? '' : String(prefix).trim()
    if (!raw) return ['A', 'B', 'C']

    const currentLetter = raw.charAt(0)

    if (
        currentLetter === 'A' ||
        currentLetter === 'À' ||
        currentLetter === 'B' ||
        currentLetter === 'C' ||
        currentLetter === 'a' ||
        currentLetter === 'à' ||
        currentLetter === 'b' ||
        currentLetter === 'c'
    ) {
        return ['A', 'B', 'C']
    }
    if (
        currentLetter === 'D' ||
        currentLetter === 'E' ||
        currentLetter === 'F' ||
        currentLetter === 'd' ||
        currentLetter === 'e' ||
        currentLetter === 'f'
    ) {
        return ['D', 'E', 'F']
    }
    if (
        currentLetter === 'G' ||
        currentLetter === 'H' ||
        currentLetter === 'I' ||
        currentLetter === 'g' ||
        currentLetter === 'h' ||
        currentLetter === 'i'
    ) {
        return ['G', 'H', 'I']
    }
    if (
        currentLetter === 'J' ||
        currentLetter === 'K' ||
        currentLetter === 'L' ||
        currentLetter === 'j' ||
        currentLetter === 'k' ||
        currentLetter === 'l'
    ) {
        return ['J', 'K', 'L']
    }
    if (
        currentLetter === 'M' ||
        currentLetter === 'N' ||
        currentLetter === 'O' ||
        currentLetter === 'm' ||
        currentLetter === 'n' ||
        currentLetter === 'o'
    ) {
        return ['M', 'N', 'O']
    }
    if (
        currentLetter === 'P' ||
        currentLetter === 'Q' ||
        currentLetter === 'R' ||
        currentLetter === 'p' ||
        currentLetter === 'q' ||
        currentLetter === 'r'
    ) {
        return ['P', 'Q', 'R']
    }
    if (
        currentLetter === 'S' ||
        currentLetter === 'T' ||
        currentLetter === 'U' ||
        currentLetter === 's' ||
        currentLetter === 't' ||
        currentLetter === 'u' ||
        currentLetter === 'Ü' ||
        currentLetter === 'ü'
    ) {
        return ['S', 'T', 'U']
    }
    if (
        currentLetter === 'V' ||
        currentLetter === 'W' ||
        currentLetter === 'X' ||
        currentLetter === 'v' ||
        currentLetter === 'w' ||
        currentLetter === 'x'
    ) {
        return ['V', 'W', 'X']
    }
    if (
        currentLetter === 'Y' ||
        currentLetter === 'Z' ||
        currentLetter === 'y' ||
        currentLetter === 'z'
    ) {
        return ['Y', 'Z']
    }

    return ['A', 'B', 'C']
}

const GOLD_BG = 'rgba(243, 191, 76, .55)'
const GOLD_BORDER = '3px solid rgba(243, 191, 76, .55)'
const LANG = 'de'

function letterKey(ch) {
    if (ch == null || String(ch) === '') return ''
    const s = String(ch)
    try {
        return s.normalize('NFKC')[0]?.toUpperCase?.() ?? s[0]?.toUpperCase?.() ?? s[0]
    } catch (_) {
        return s[0].toUpperCase()
    }
}

function bucketHas(bucket, btnLetter) {
    if (!btnLetter) return false
    const u = letterKey(btnLetter)
    return bucket.some((x) => letterKey(x) === u || String(x).localeCompare(String(btnLetter), LANG, { sensitivity: 'base' }) === 0)
}

/** Book / paid dictionary buckets (À, Ü…) */
export const FILTER_BUCKETS_BOOK = [
    ['A', 'À', 'D', 'G', 'J', 'M', 'P', 'S', 'V', 'Y', 'a', 'à', 'd', 'g', 'j', 'm', 'p', 's', 'v', 'y'],
    ['B', 'E', 'H', 'K', 'N', 'Q', 'T', 'W', 'Z', 'b', 'e', 'h', 'k', 'n', 'q', 't', 'w', 'z'],
    ['C', 'F', 'I', 'L', 'O', 'R', 'U', 'Ü', 'X', 'c', 'f', 'i', 'l', 'o', 'r', 'u', 'ü', 'x'],
]

/** Open dictionary buckets (without À / Ü como en OpenDictionary.js) */
export const FILTER_BUCKETS_OPEN = [
    ['A', 'D', 'G', 'J', 'M', 'P', 'S', 'V', 'Y', 'a', 'd', 'g', 'j', 'm', 'p', 's', 'v', 'y'],
    ['B', 'E', 'H', 'K', 'N', 'Q', 'T', 'W', 'Z', 'b', 'e', 'h', 'k', 'n', 'q', 't', 'w', 'z'],
    ['C', 'F', 'I', 'L', 'O', 'R', 'U', 'X', 'c', 'f', 'i', 'l', 'o', 'r', 'u', 'x'],
]

/**
 * @param {object} opts
 * @param {string} opts.currentSearch
 * @param {string} opts.btnLetter Etiqueta del botón letters[i]
 * @param {string[]} opts.trioLetters currentLetters truncado o array del trío visible
 * @param {number} opts.columnIdx 0|1|2
 * @param {string[][]} opts.buckets FILTER_BUCKETS_BOOK | FILTER_BUCKETS_OPEN
 * @param {boolean} opts.bookDialect true → regla especial U solo + letra Ü (Dictionary/Basic)
 */
export function styleForLetterFilterButton(opts) {
    const {
        currentSearch,
        currentLetter,
        btnLetter,
        trioLetters,
        columnIdx,
        buckets,
        bookDialect,
    } = opts
    const trio = Array.isArray(trioLetters) ? trioLetters.slice(0, 3).filter(Boolean) : []
    const bucket = buckets[columnIdx] || []

    const style = {
        backgroundColor: 'none',
        border: '',
    }

    if (!btnLetter || !trio.some((x) => String(x) === String(btnLetter))) return style

    const trimmed =
        typeof currentSearch === 'string' ? currentSearch.trim() : String(currentSearch || '').trim()

    if (!bucketHas(bucket, btnLetter)) return style

    const lc = trimmed.length === 0 ? '' : trimmed.charAt(0)
    const isOneLetter = trimmed.length === 1 && /\p{L}/u.test(trimmed)

    let fullBg = false
    if (isOneLetter && btnLetter) {
        fullBg =
            trimmed.localeCompare(btnLetter, LANG, { sensitivity: 'base' }) === 0
    }

    if (bookDialect && columnIdx === 2 && (btnLetter === 'Ü' || btnLetter === 'ü')) {
        if (trimmed === 'U' && currentLetter === 'Ü') fullBg = true
    }

    let outlineOnly = false
    if (!fullBg && trimmed.length >= 2 && lc && btnLetter) {
        outlineOnly =
            lc.localeCompare(btnLetter, LANG, { sensitivity: 'base' }) === 0 && /\p{L}/u.test(lc)
    }

    if (fullBg) {
        style.backgroundColor = GOLD_BG
    }
    if (outlineOnly) {
        style.border = GOLD_BORDER
    }

    return style
}
